import { ref } from "vue"
import { Subject } from "rxjs";

//#region type definitions
/**
 * @typedef {Object} ObserveEvent
 * @property {string} name - event name
 * @property {import("rxjs").Subject} subscriber
 */

/**
 * @callback FuncOn
 * @param {string} eventName
 * @returns {import("rxjs").Subject}
 */

/**
 * @callback FuncOff
 * @param {string} eventName
 */

/**
 * @callback FuncEmit
 * @param {string} eventName
 * @param {data=} data
 */

/**
 * @typedef {Object} ObserverMethods
 * @property {FuncOn} on
 * @property {FuncOff} off
 * @property {FuncEmit} emit
 */

/**
 * @typedef {import("@vue/reactivity").Ref<import("rxjs").Subscription>} VueSubscription
 */
//#endregion

export const useObserver = function () {
    /**@type {import("@vue/reactivity").Ref<ObserveEvent[]>} */
    const subjects = ref([])

    /**
     * 
     * @param {string} eventName 
     * @returns {import("rxjs").Subject}
     */
    const on = function (eventName) {
        let exists = subjects.value.find(x => x.name == eventName)
        if (exists != null) {
            return exists.subscriber
        } else {
            const subject = new Subject()
            subjects.value.push({
                name: eventName,
                subscriber: subject
            })

            // console.log(subject)

            return subject
        }
    }

    /**
     * 
     * @param {string} eventName 
     */
    const off = function (eventName) {
        let exists = subjects.value.findIndex(x => x.name == eventName)
        if (exists > -1) {
            subjects.value.splice(exists, 1)
        }
    }

    /**
     * 
     * @param {string} eventName 
     * @param {*} data 
     */
    const emit = function (eventName, data = null) {
        let event = subjects.value.find(x => x.name == eventName)
        // console.log(eventName, event, data)
        if (event != null) {
            event.subscriber.next(data)
        }
    }

    return {
        on,
        off,
        emit
    }
}

export default useObserver